<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div class="card-body">
              <h1>{{ article.title }}</h1>
              <small
                ><time>{{ article.date }}</time></small
              >
              <article>
                {{ article.text }}
              </article>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      article: {},
    };
  },
  methods: {
    load() {
      axios
        .get(
          window.base +
            "/news/" +
            this.$route.params.item +
            "?lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          this.article = response.data;
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>
